export const SET_SAVING_LOCATION = "SET_SAVING_LOCATION";
export const RESET_SAVING_LOCATION = "RESET_SAVING_LOCATION";
export const ADD_WORKING_DIRECTORY = "ADD_WORKING_DIRECTORY";
export const ADD_WORKING_DIRECTORIES = "ADD_WORKING_DIRECTORIES";
export const SET_WORKING_DIRECTORIES = "SET_WORKING_DIRECTORIES";
export const SET_ONE_DRIVE_DETAILS = "SET_ONE_DRIVE_DETAILS";
export const REMOVE_WORKING_DIRECTORY = "REMOVE_WORKING_DIRECTORY";
export const RESET_WORKING_DIRECTORY = "RESET_WORKING_DIRECTORY";
export const REMOVE_WORKING_DIRECTORIES_BY_INDEX = "REMOVE_WORKING_DIRECTORIES_BY_INDEX";
export const REMOVE_WORKING_DIRECTORIES_BY_INDEX_INDEX_AND_ADD_ITEM = "REMOVE_WORKING_DIRECTORIES_BY_INDEX_AND_ADD_ITEM";
export const SET_TENANT_INFO = "SET_TENANT_INFO";
export const SET_DATASOURCE = "SET_DATASOURCE";
export const TOGGLE_LOADING = "TOGGLE_LOADING";
export const RESET_FILES = "RESET_FILES";
export const SET_FILES = "SET_FILES";
export const SET_COMPOSE_FILES = "SET_COMPOSE_FILES";
export const SET_COMPOSE_VISIBILITY = "SET_COMPOSE_VISIBILITY";
export const RESET_COMPOSE = "RESET_COMPOSE";
export const SET_FILE = "SET_FILE";
export const ADD_UPLOADED_FILE = "ADD_UPLOADED_FILE";
export const ADD_UPLOADED_FILES = "ADD_UPLOADED_FILES";
export const SET_DUPLICATE_EMAILS = "SET_DUPLICATE_EMAILS";
export const SET_FILES_EXPANDER = "SET_FILES_EXPANDER";
export const SET_FILES_CAN_OVERWRITE = "SET_FILES_CAN_OVERWRITE";
export const SET_FILES_ONE_DRIVE_OVERWRITE_OPTION_IS_SELECTED = "SET_FILES_ONE_DRIVE_OVERWRITE_OPTION_IS_SELECTED";
export const SET_FILE_SELECTED = "SET_FILE_SELECTED";
export const REMOVE_FILE = "REMOVE_FILE";
export const DELETE_FILES_BY_ORIGINALNAME = "DELETE_FILES_BY_ORIGINALNAME";
export const UPDATE_FILE_NAME = "UPDATE_FILE_NAME";
export const SET_IS_SAVING_IN_BACKGROUND = "SET_IS_SAVING_IN_BACKGROUND";
export const SET_NEEDS_REDIRECT_TO_HOME = "SET_NEEDS_REDIRECT_TO_HOME";
export const SET_IS_BUSY_SAVING = "SET_IS_BUSY_SAVING";
export const SET_IS_CHECKING_DUPLICATES = "SET_IS_CHECKING_DUPLICATES";
export const SET_IS_LOADING_METADATA = "SET_IS_LOADING_METADATA";
export const SET_OVERLAY_VISIBILITY = "SET_OVERLAY_VISIBILITY";
export const SIGNAL_CACHE_UPDATE = "SIGNAL_CACHE_UPDATE";
export const TOGGLE_RELOAD = "TOGGLE_RELOAD";
export const REFRESH_RELOAD = "REFRESH_RELOAD";
export const RESET_REFRESH = "RESET_REFRESH";
export const SET_LOADING = "SET_LOADING";
export const INCREMENT_AMOUNT_LOADING = "INCREMENT_AMOUNT_LOADING";
export const DECREMENT_AMOUNT_LOADING = "DECREMENT_AMOUNT_LOADING";
export const ADD_FOLDER = "ADD_FOLDER";
export const GET_FOLDERS = "GET_FOLDERS";
export const SET_CURRENT_SHAREPOINT_FOLDER_CAN_VIEW = "SET_CURRENT_SHAREPOINT_FOLDER_CAN_VIEW";
export const SET_SHAREPOINT_INFO = "SET_SHAREPOINT_INFO";
export const SET_IS_SITES_LOADING = "SET_IS_SITES_LOADING";
export const SET_SITES_LAST_CACHE_REFRESH = "SET_SITES_LAST_CACHE_REFRESH";
export const RESET_SHAREPOINT_INFO = "RESET_SHAREPOINT_INFO";
export const SET_MODE = "SET_MODE";
export const SET_EXPANDED_ITEM = "SET_EXPANDED_ITEM";
export const SET_USER_LICENSE_TYPE = "SET_USER_LICENSE_TYPE";
export const SET_USER_FULL_PROFILE = "SET_USER_FULL_PROFILE";

export const SET_SHOW_FOLDER_DELETE_DIALOG = "SET_SHOW_FOLDER_DELETE_DIALOG";

export const SET_USER_RECENT_ITEMS = "SET_USER_RECENT_ITEMS";
export const SET_USER_PINNED_ITEMS = "SET_USER_PINNED_ITEMS";
export const SET_USER_SUGGESTED_ITEMS = "SET_USER_SUGGESTED_ITEMS";
export const SET_USER_SHARED_ITEMS = "SET_USER_SHARED_ITEMS";
export const SET_PINNED_IS_LOADING = "SET_PINNED_IS_LOADING";
export const SET_SUGGESTED_IS_LOADING = "SET_SUGGESTED_IS_LOADING";
export const SET_RECENT_IS_LOADING = "SET_RECENT_IS_LOADING";
export const SET_SHARED_IS_LOADING = "SET_SHARED_IS_LOADING";
export const ADD_USER_RECENT_ITEM = "ADD_USER_RECENT_ITEM";
export const ADD_USER_PINNED_ITEM = "ADD_USER_PINNED_ITEM";
export const ADD_USER_SUGGESTED_ITEM = "ADD_USER_SUGGESTED_ITEM";
export const ADD_USER_SHARED_ITEM = "ADD_USER_SHARED_ITEM";
export const GET_USER_RECENT_ITEMS = "GET_USER_RECENT_ITEMS";
export const GET_USER_PINNED_ITEMS = "GET_USER_PINNED_ITEMS";
export const GET_USER_SUGGESTED_ITEMS = "GET_USER_SUGGESTED_ITEMS";
export const GET_USER_SHARED_ITEMS = "GET_USER_SHARED_ITEMS";
export const DELETE_USER_RECENT_ITEM = "DELETE_USER_RECENT_ITEM";
export const DELETE_USER_PINNED_ITEM = "DELETE_USER_PINNED_ITEM";
export const DELETE_USER_SUGGESTED_ITEM = "DELETE_USER_SUGGESTED_ITEM";
export const DELETE_USER_SHARED_ITEM = "DELETE_USER_SHARED_ITEM";

export const RESET_USER_RECENT_ITEMS = "RESET_USER_RECENT_ITEMS";
export const RESET_USER_PINNED_ITEMS = "RESET_USER_PINNED_ITEMS";
export const RESET_USER_SUGGESTED_ITEMS = "RESET_USER_SUGGESTED_ITEMS";
export const RESET_USER_SHARED_ITEMS = "RESET_USER_SHARED_ITEMS";
export const RESET_HOME_ITEMS = "RESET_HOME_ITEMS";

export const SET_USER_ONE_DRIVE_URL = "SET_USER_ONE_DRIVE_URL";

export const SET_USER_ACCOUNT = "SET_USER_ACCOUNT";
export const RESET_USER_ACCOUNT = "RESET_USER_ACCOUNT";
export const SET_SEARCH = "SET_SEARCH";
export const SET_IS_IN_SEARCH_MODE = "SET_IS_IN_SEARCH_MODE";
export const SET_SEARCH_FILTER_TYPE = "SET_SEARCH_FILTER_TYPE";
export const SET_IS_TEAMS_LOADING = "SET_IS_TEAMS_LOADING";
export const SET_TEAMS_LAST_SERVER_REFRESH = "SET_TEAMS_LAST_SERVER_REFRESH";
export const SET_TEAMS_LAST_CACHE_REFRESH = "SET_TEAMS_LAST_CACHE_REFRESH";
export const SET_TEAMS = "SET_TEAMS";
export const SET_TEAM_CHANNELS = "SET_TEAM_CHANNELS";
export const RESET_TEAMS = "RESET_TEAMS";
export const SET_ONE_DRIVE_LOCATION_BEFORE_SAVING = "SET_ONE_DRIVE_LOCATION_BEFORE_SAVING";
export const RESET_DRIVE_LOCATION_BEFORE_SAVING = "RESET_DRIVE_LOCATION_BEFORE_SAVING";
export const ADD_REGIONAL_SETTINGS = "ADD_REGIONAL_SETTINGS";

export const SET_USER_PROFILE = "SET_USER_PROFILE";
export const SET_USER_SETTINGS = "SET_USER_SETTINGS";

export const CLEAR_ALL_STATE = "CLEAR_ALL_STATE";
export const RESET_APPROVALS = "RESET_APPROVALS";
export const SET_IS_APPROVALS_LOADING = "SET_IS_APPROVALS_LOADING";
export const SET_APPROVALS = "SET_APPROVALS";
export const SET_APPROVALSCOUNT = "SET_APPROVALSCOUNT";
export const SET_LAST_APPROVAL_LOAD = "SET_LAST_APPROVAL_LOAD";
export const REMOVE_APPROVAL = "REMOVE_APPROVAL";

export const SET_CONTENT_MANAGER_DIRECTORY = "SET_CONTENT_MANAGER_DIRECTORY";
export const RESET_CONTENT_MANAGER_DIRECTORY = "RESET_CONTENT_MANAGER_DIRECTORY";
export const SET_IS_CONTENT_MANAGER_CONTENT_LOADING = "SET_IS_CONTENT_MANAGER_CONTENT_LOADING";
export const SET_IS_CONTENT_MANAGER_SIDEMENU_COLLAPSED = "SET_IS_CONTENT_MANAGER_SIDEMENU_COLLAPSED";
export const TOGGLE_IS_CONTENT_MANAGER_SIDEMENU_COLLAPSED = "TOGGLE_IS_CONTENT_MANAGER_SIDEMENU_COLLAPSED";
export const SET_CONTENT_MANAGER_FILTER_VALUE = "SET_CONTENT_MANAGER_FILTER_VALUE";
export const SET_CONTENT_MANAGER_SEARCH_VALUE = "SET_CONTENT_MANAGER_SEARCH_VALUE";
export const SET_CONTENT_MANAGER_SEARCH_FILTER_TYPE = "SET_CONTENT_MANAGER_SEARCH_FILTER_TYPE";
export const TOGGLE_CONTENT_MANAGER_RELOAD = "TOGGLE_CONTENT_MANAGER_RELOAD";
export const SET_CONTENT_MANAGER_FILTER_FIELDS = "SET_CONTENT_MANAGER_FILTER_FIELDS";
export const SET_CONTENT_MANAGER_FILTER_SECTIONS = "SET_CONTENT_MANAGER_FILTER_SECTIONS";
export const SET_CONTENT_MANAGER_FILTER_SECTIONS_RESET = "SET_CONTENT_MANAGER_FILTER_SECTIONS_RESET";
export const SET_CONTENT_MANAGER_FILTER_SECTION_ITEM = "SET_CONTENT_MANAGER_FILTER_SECTION_ITEM";
export const SET_CONTENT_MANAGER_FILTER_SECTION_ITEMS = "SET_CONTENT_MANAGER_FILTER_SECTION_ITEMS";
export const SET_CONTENT_MANAGER_FILTER_SECTION_ITEMS_FROM_RANGE = "SET_CONTENT_MANAGER_FILTER_SECTION_ITEMS_FROM_RANGE";
export const SET_CONTENT_MANAGER_FILTER_SECTION_TOGGLE_SHOW_MORE = "SET_CONTENT_MANAGER_FILTER_SECTION_TOGGLE_SHOW_MORE";
export const SET_CONTENT_MANAGER_FILTER_SECTION_TOGGLE_SLIDER = "SET_CONTENT_MANAGER_FILTER_SECTION_TOGGLE_SLIDER";
export const SET_CONTENT_MANAGER_MOVETO_MOVETOENABLED = "SET_CONTENT_MANAGER_MOVETO_MOVETOENABLED";
export const SET_CONTENT_MANAGER_MOVETO_WORKING_DIRECTORIES = "SET_CONTENT_MANAGER_MOVETO_WORKING_DIRECTORIES";
export const SET_CONTENT_MANAGER_MOVETO_SELECTED_FILES = "SET_CONTENT_MANAGER_MOVETO_SELECTED_FILES";
export const SET_CONTENT_MANAGER_MOVETO_SITEURL = "SET_CONTENT_MANAGER_MOVETO_SITEURL";
export const SET_CONTENT_MANAGER_MOVETO_SOURCE_SERVERRELPATH = "SET_CONTENT_MANAGER_MOVETO_SOURCE_SERVERRELPATH";
export const SET_CONTENT_MANAGER_MOVETO_BUSYMOVINGFILES = "SET_CONTENT_MANAGER_MOVETO_SOURCE_BUSYMOVINGFILES";
export const SET_CONTENT_MANAGER_MOVETO_SELECTED_FILES_ISBUSY_PROGRESS = "SET_CONTENT_MANAGER_MOVETO_SELECTED_FILES_ISBUSY_PROGRESS";
export const SET_CONTENT_MANAGER_MOVETO_COPYJOBRESULTS = "SET_CONTENT_MANAGER_MOVETO_COPYJOBRESULTS";
export const SET_CONTENT_MANAGER_MOVETO_ADDTO_COPYJOBRESULTS = "SET_CONTENT_MANAGER_MOVETO_ADDTO_COPYJOBRESULTS";
export const SET_CONTENT_MANAGER_MOVETO_COPYJOBRESULTS_IDS_TO_REMOVE = "SET_CONTENT_MANAGER_MOVETO_COPYJOBRESULTS_IDS_TO_REMOVE";
export const SET_CONTENT_MANAGER_MOVETO = "SET_CONTENT_MANAGER_MOVETO";
export const SET_CONTENT_MANAGER_MOVETO_ERROR = "SET_CONTENT_MANAGER_MOVETO_ERROR";
export const SET_CONTENT_MANAGER_MOVETO_COMPLETED_ITEM_COUNT = "SET_CONTENT_MANAGER_MOVETO_COMPLETED_JOB_COUNT";
export const SET_CONTENT_MANAGER_EXCHANGE = "SET_CONTENT_MANAGER_EXCHANGE";
export const SET_CONTENT_MANAGER_EXCHANGE_PROGRESS = "SET_CONTENT_MANAGER_EXCHANGE_PROGRESS";
export const SET_CONTENT_MANAGER_EXCHANGE_ADDITIONAL_MAILBOXES = "SET_CONTENT_MANAGER_EXCHANGE_ADDITIONAL_MAILBOXES";
export const SET_CONTENT_MANAGER_SELECTED_HOME_SECTION = "SET_CONTENT_MANAGER_SELECTED_HOME_SECTION";
export const RESET_CONTENT_MANAGER_MOVETO = "RESET_CONTENT_MANAGER_MOVETO";